import React from "react";
import Header from "../../Partials/Header/Header";
import Footer from "../../Partials/Footer/Footer";
import Body from "./Body";
import Integrator from "../../Components/Integrator/Integrator";

export default class BusinessBenefits extends React.Component {
  render() {
    return (
      <div className="integrator-wrapper">
        <Header />
        <Body />
        <Integrator />
        <Footer />
      </div>
    );
  }
}